import Component from '@glimmer/component';

import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { Modal } from 'ember-primitives';

import CButton from 'rise-ui/components/c-button.gjs';
import CIdentity from 'rise-ui/components/c-identity.gjs';
import { call } from 'rise-ui/utils/function.js';

export default class ModalButtonComponent extends Component {
  modal;
  @action setModal(modal) {
    this.modal = modal;
  }

  @action cancelAction(...args) {
    this.modal?.close();
    call(this.args.onCancel, null, false, ...args);
  }

  @action submitAction(...args) {
    this.modal?.close();
    call(this.args.onSubmit, null, true, ...args);
  }

  <template>
    <Modal @onClose={{this.cancelAction}} as | modal |>
      {{this.setModal modal}}
      <CButton class="c-modal-button"
        @disabled={{@disabled}}
        @title={{@title}}
        {{on "click" modal.open}}
        {{modal.focusOnClose}}
        ...attributes
      >
        {{yield (hash button=(component CIdentity))}}
      </CButton>
      <modal.Dialog>
        <div class="c-modal-button__modal">
          {{~yield (hash
             body=(component CIdentity)
             cancel=this.cancelAction
             submit=this.submitAction
           )~}}
        </div>
      </modal.Dialog>
    </Modal>
  </template>
}
